// @ts-nocheck
import React, { useEffect } from "react";
import {
  ArrowRight,
  ShieldCheck,
  Zap,
  Clock3
} from "lucide-react";

const colors = {
  bgTop: "#050816",
  bgBottom: "#111827",
  primary: "#19E6FF",
  accentBlue: "#38bdf8",
  accentPurple: "#C084FC",
  cardBg: "rgba(15,23,42,0.95)",
  cardBorder: "rgba(148,163,184,0.35)",
  text: "#e5e7eb",
  textMuted: "#9ca3af",
};

export default function CaseMasterPage() {
  useEffect(() => {
    document.title = "CaseMaster — Orion Intelligence";
    return () => {
      document.title = "Orion Intelligence";
    };
  }, []);

  return (
    <div
      className="min-h-screen text-white flex flex-col"
      style={{
        background: `radial-gradient(1200px 600px at 0% 0%, rgba(56,189,248,0.14), transparent 60%),
                     radial-gradient(1000px 500px at 100% 0%, rgba(192,132,252,0.18), transparent 55%),
                     linear-gradient(${colors.bgTop}, ${colors.bgBottom})`,
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex-grow flex flex-col items-center justify-center text-center">
        {/* Orion Logo */}
        <div className="flex items-center gap-3 mb-12">
          <img
            src="/assets/orion-logo-800.png"
            alt="Orion Intelligence logo"
            className="w-12 h-12 rounded-xl"
            style={{ boxShadow: "0 0 0 2px rgba(25,230,255,0.25)" }}
          />
          <div className="text-left leading-tight">
            <div className="text-xl font-bold tracking-wide" style={{ color: colors.primary }}>
              Orion Intelligence
            </div>
            <div className="text-xs opacity-70">CaseMaster Suite</div>
          </div>
        </div>

        <h1 className="text-4xl md:text-6xl font-black mb-4 leading-tight">
          CaseMaster
        </h1>

        <div
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-8"
          style={{ borderColor: "rgba(25,230,255,0.5)", background: "rgba(25,230,255,0.1)", color: "#19E6FF" }}
        >
          <Zap size={14} />
          <span className="text-xs font-bold uppercase tracking-widest">Παρουσίαση προϊόντος</span>
        </div>

        <p className="text-lg md:text-xl max-w-2xl mb-12 text-blue-100/80 leading-relaxed font-medium">
          Η πιο σύγχρονη πλατφόρμα οργάνωσης για νομικούς επαγγελματίες στην Ελλάδα.
          Διαχειριστείτε τις υποθέσεις σας και το πελατολόγιό σας απρόσκοπτα.
          Το προϊόν παραμένει ορατό ως έργο της Orion Intelligence, αλλά δεν διατίθεται προς αγορά αυτή την περίοδο.
        </p>

        {/* Benefits Preview */}
        <div className="grid sm:grid-cols-2 gap-4 w-full max-w-2xl mb-12">
          {[
            "Πλήρης οργάνωση υποθέσεων",
            "AI Agent για νομική υποστήριξη",
            "GDPR-ready ασφάλεια",
            "Live συγχρονισμός παντού"
          ].map((feature, i) => (
            <div key={i} className="flex items-center gap-3 p-4 rounded-2xl border" style={{ background: colors.cardBg, borderColor: colors.cardBorder }}>
              <ShieldCheck size={20} className="text-cyan-400" />
              <span className="text-sm font-semibold">{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="/#contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-2xl font-bold transition-all hover:scale-105"
            style={{ background: colors.primary, color: "#001018" }}
          >
            <Clock3 size={18} />
            Ενημερωθείτε για το προϊόν
          </a>
          
          <a
            href="/"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-2xl font-bold transition-all hover:scale-105 border border-white/10"
            style={{ background: colors.cardBg, color: colors.text }}
          >
            Επιστροφή στην Αρχική
            <ArrowRight size={18} />
          </a>
        </div>
      </div>

      <footer className="py-10 text-center opacity-40 text-xs tracking-widest uppercase">
        Orion Intelligence © 2026 • Legal Technology
      </footer>
    </div>
  );
}
